import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import { useCore } from 'contexts/core';
import { useAppDispatch } from 'ducks/hooks';
import { PlatsaSoftClosingHingeComponent } from '@inter-ikea-storageone/range-platsa';
import Modal, { ModalFooter, ModalHeader, ModalBody, Sheets } from '@ingka/modal';
import styled from 'styled-components';
import SoftClosingHingeImage from './SoftClosingHingeImage.jpg';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import Body from 'ui/Typography/Body';
import Title, { HeadingType } from 'ui/Typography/Title';
import Button from '@ingka/button';
import { hideSoftClosingHingesSheet, isModalVisible } from './SoftClosingHingesFeature';

const Image = styled.img`
  width: 100%;
  padding: 0.5rem 4.5rem;

  @media (min-width: 600px) {
    padding: 2rem;
  }
`;

function PlatsaSoftClosingHingeInfoSheet() {
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const visible = useSelector(isModalVisible);
  const coreApi = useCore();
  const scene = coreApi.entities.getScene();

  const onHidePlatsaSoftClosingInfoSheet = () => {
    dispatch(hideSoftClosingHingesSheet());
  };

  const onSelect = () => {
    coreApi.history.historyAction(() => {
      scene?.addComponent(new PlatsaSoftClosingHingeComponent());
      onHidePlatsaSoftClosingInfoSheet();
    });
  };

  return (
    <Modal visible={visible} handleCloseBtn={onHidePlatsaSoftClosingInfoSheet}>
      <Sheets
        title={formatMessage({ id: 'storageone.platsaSoftClosingHingeInfoSheetTitle' })}
        header={
          <ModalHeader
            data-testid="modal-header"
            ariaCloseTxt={formatMessage({ id: 'storageone.closeButton' })}
          />
        }
        footer={
          <ModalFooter>
            <Button
              text={formatMessage({ id: 'storageone.platsaSoftClosingHingeInfoSheetButton' })}
              onClick={onSelect}
              type="primary"
              data-testid="cover-caps-sheet-finalize-btn"
              fluid
            />
          </ModalFooter>
        }
      >
        <ModalBody style={{ paddingTop: '0px' }}>
          <Title
            mb="l"
            type={ThemeFontStyleTypeEnum.headingMedium}
            heading={HeadingType.HeadingTwo}
          >
            {formatMessage({ id: 'storageone.platsaSoftClosingHingeInfoSheetTitle' })}
          </Title>
          <Body type={ThemeFontStyleTypeEnum.bodyMedium}>
            {formatMessage({ id: 'storageone.platsaSoftClosingHingeInfoSheetDescription' })}
          </Body>
          <Body mt="md" type={ThemeFontStyleTypeEnum.bodyMedium}>
            {formatMessage({ id: 'storageone.platsaSoftClosingHingeInfoSheetSecondDescription' })}
          </Body>
          <Image
            src={SoftClosingHingeImage}
            alt={formatMessage({ id: 'storageone.platsaSoftClosingHingeInfoSheetTitle' })}
          />
        </ModalBody>
      </Sheets>
    </Modal>
  );
}

export default PlatsaSoftClosingHingeInfoSheet;
